<template>
    <div style="margin: 80px 0;">
        <!-- 标题区域 -->
        <div class="about_one"
            style="font-size: 35px;color: black;justify-content: center;flex-direction: column;margin-top: 180px;">
            <div id="section3">精细化管理模式</div>
            <div style="display: flex;flex-direction: row;font-weight: normal;">
                <div class="line"></div>
                <div class="title" style="font-size: 25px;padding: 0 15px;">Refined Management Model</div>
                <div class="line"></div>
            </div>
        </div>
        <!-- 内容区域：左右两栏布局 -->
        <div class="management-container">
            <!-- 左侧：机床品质管控标准 -->
            <div class="management-column">
                <h2 class="column_title">
                    <span class="title_num">01</span>
                    <span class="title_text">{{ $t("user.managementh1") }}</span>
                    <hr class="line">
                </h2>
                <!-- 图片+描述 行1 -->
                <div class="row">
                    <div class="Mitem">
                        <el-image :src="require('@/assets/management/图1-1_01.png')" alt="线轨的平行度平面度要求在0.01mm以内"
                            style="width: 99%;" :preview-src-list="[require('@/assets/management/图1-1_01.png')]" />
                        <p class="Mitem_text">● {{ $t("user.managementh1_1") }}</p>

                    </div>
                    <div class="Mitem">
                        <el-image :src="require('@/assets/management/图1-1_02.png')" alt="主轴联轴器同心度要求在 0.005mm 以内"
                            style="width: 99%;" :preview-src-list="[require('@/assets/management/图1-1_02.png')]" />
                        <p class="Mitem_text">● {{ $t("user.managementh1_2") }}</p>

                    </div>
                </div>
                <!-- 图片+描述 行2 -->
                <div class="row">
                    <div class="Mitem">
                        <el-image :src="require('@/assets/management/图1-2_01.png')" alt="主轴安装面平面度在 0.005mm 以内"
                            style="width: 99%;" :preview-src-list="[require('@/assets/management/图1-2_01.png')]" />
                        <p class="Mitem_text">● {{ $t("user.managementh1_3") }}</p>


                    </div>
                    <div class="Mitem">
                        <el-image :src="require('@/assets/management/图1-2_02.png')" alt="主轴联轴器同心度要求在 0.005mm 以内"
                            style="width: 99%;" :preview-src-list="[require('@/assets/management/图1-2_02.png')]" />
                        <p class="Mitem_text">● {{ $t("user.managementh1_4") }}</p>

                    </div>
                    <div class="Mitem">
                        <el-image :src="require('@/assets/management/图1-2_03.png')" alt="主轴联轴器同心度要求在 0.005mm 以内"
                            style="width: 99%;" :preview-src-list="[require('@/assets/management/图1-2_03.png')]" />
                        <p class="Mitem_text">● {{ $t("user.managementh1_5") }}</p>

                    </div>
                </div>
                <!-- 图片+描述 行3 -->
                <div class="row">
                    <div class="Mitem">
                        <el-image :src="require('@/assets/management/图1-3_01.png')" alt="主轴安装面平面度在 0.005mm 以内"
                            style="width: 99%;" :preview-src-list="[require('@/assets/management/图1-3_01.png')]" />
                        <p class="Mitem_text">● {{ $t("user.managementh1_6") }}</p>


                    </div>
                    <div class="Mitem">
                        <el-image :src="require('@/assets/management/图1-3_02.png')" alt="主轴联轴器同心度要求在 0.005mm 以内"
                            style="width: 99%;" :preview-src-list="[require('@/assets/management/图1-3_02.png')]" />
                        <p class="Mitem_text">● {{ $t("user.managementh1_7") }}</p>

                    </div>
                </div>
            </div>
            <!-- 右侧：精益求精，铸就精品 -->
            <div class="management-column">
                <h2 class="column_title">
                    <span class="title_num">02</span>
                    <span class="title_text">{{ $t("user.managementh2") }}</span>
                    <hr class="line">
                </h2>
                <!-- 图片+描述 行1 -->
                <div class="row">
                    <div class="Mitem">
                        <el-image :src="require('@/assets/management/图2-1_01.png')" alt="主轴振动要求在3um以内"
                            style="width: 99%;" :preview-src-list="[require('@/assets/management/图2-1_01.png')]" />
                        <p class="Mitem_text">● {{ $t("user.managementh2_1") }}</p>

                    </div>
                    <div class="Mitem">
                        <el-image :src="require('@/assets/management/图2-1_02.png')" alt="实物加工检测" style="width: 99%;"
                            :preview-src-list="[require('@/assets/management/图2-1_02.png')]" />
                        <p class="Mitem_text">● {{ $t("user.managementh2_2") }}</p>

                    </div>
                    <div class="Mitem">
                        <el-image :src="require('@/assets/management/图2-1_03.png')" alt="球杆仪真圆度300mm在0.01mm以内"
                            style="width: 99%;" :preview-src-list="[require('@/assets/management/图2-1_03.png')]" />
                        <p class="Mitem_text">● {{ $t("user.managementh2_3") }}</p>

                    </div>
                </div>
                <div class="row" style="margin-top: 45px;">
                    <div class="Mitem">
                        <el-image :src="require('@/assets/management/图2-2_01.png')" alt="主轴噪音检测" style="width: 99%;"
                            :preview-src-list="[require('@/assets/management/图2-2_01.png')]" />
                        <p class="Mitem_text">● {{ $t("user.managementh2_4") }}</p>


                    </div>
                    <div class="Mitem">
                        <el-image :src="require('@/assets/management/图2-2_02.png')" alt="主轴温升检测" style="width: 99%;"
                            :preview-src-list="[require('@/assets/management/图2-2_02.png')]" />
                        <p class="Mitem_text">● {{ $t("user.managementh2_5") }}</p>

                    </div>
                    <div class="Mitem">
                        <el-image :src="require('@/assets/management/图2-2_03.png')" alt="激光镭射检测及校正补偿"
                            style="width: 99%;" :preview-src-list="[require('@/assets/management/图2-2_03.png')]" />
                        <p class="Mitem_text">● {{ $t("user.managementh2_6") }}</p>

                    </div>
                </div>
                <div class="row" style="margin-top: 55px;">
                    <div class="Mitem">
                        <el-image :src="require('@/assets/management/图2-3_01.png')" alt="主轴偏摆 300mm 在 0.008mm 以内"
                            style="width: 100%;" :preview-src-list="[require('@/assets/management/图2-3_01.png')]" />
                        <p class="Mitem_text">● {{ $t("user.managementh2_7") }}</p>


                    </div>
                    <div class="Mitem">
                        <el-image :src="require('@/assets/management/图2-3_02.png')" alt="工作台平面度在 0.02mm 以内"
                            style="width: 100%;" :preview-src-list="[require('@/assets/management/图2-3_02.png')]" />
                        <p class="Mitem_text">● {{ $t("user.managementh2_8") }}</p>
                    </div>
                    <div class="Mitem">
                        <el-image :src="require('@/assets/management/图2-3_03.png')" alt="主轴拉力刀力检测" style="width: 100%;"
                            :preview-src-list="[require('@/assets/management/图2-3_03.png')]" />
                        <p class="Mitem_text">● {{ $t("user.managementh2_9") }}</p>

                    </div>
                </div>
            </div>
        </div>
        <div class="management-container">
            <div class="management-column">
                <h2 class="column_title">
                    <span class="title_num">03</span>
                    <span class="title_text">{{ $t("user.managementh3") }}</span>
                    <hr class="line">
                </h2>
            </div>
        </div>
        <!-- 3 -->
        <div class="three">
            <div class="three_left">
                <ul class="three_ul">
                    <li>{{ $t("user.managementh3_1") }}</li>
                    <li>{{ $t("user.managementh3_2") }}</li>
                    <li>{{ $t("user.managementh3_3") }}</li>
                    <li>{{ $t("user.managementh3_4") }}</li>
                </ul>
            </div>
            <div class="three_right">
                <ul class="three_ul">
                    <li>{{ $t("user.managementh3_5") }}</li>
                    <li>{{ $t("user.managementh3_6") }}</li>
                    <li>{{ $t("user.managementh3_7") }}</li>
                    <li>{{ $t("user.managementh3_8") }}</li>
                </ul>
            </div>
        </div>
        <!-- three4格 -->
        <div class="three_main">
            <div class="three_main_item">
                <div class="title">SNCM21</div>
                <div class="content">主轴为日本镍铬钼钢材质</div>
            </div>
            <div class="three_main_item">
                <div class="title">P4(NSK)</div>
                <div class="content">世界知名厂牌 P4(NSK) 轴承</div>
            </div>
            <div class="three_main_item">
                <div class="title">KLUBER NBU15</div>
                <div class="content">油脂润滑</div>
            </div>
            <div class="three_main_item">
                <div class="title">ISO1940</div>
                <div class="content">校验主轴平衡达到 ISO1940 规范 G1 等级</div>
            </div>
        </div>
        <!-- 4章 -->
        <div class="management-container">
            <div class="management-column">
                <h2 class="column_title">
                    <span class="title_num">04</span>
                    <span class="title_text">{{ $t("user.managementh4") }}</span>
                    <hr class="line">
                </h2>
            </div>
        </div>
        <!-- four -->
        <div class="four">
            <div class="four_item">
                <div class="four_item_title">
                    <h1>{{ $t("user.managementh4_1") }}</h1>
                    <p>{{ $t("user.managementh4_2") }}</p>
                </div>
                <div class="four_item_content">
                    <el-image :src="require('@/assets/management/图4-1.png')" alt="" style="width: 100%;"
                        :preview-src-list="[require('@/assets/management/图4-1.png')]" />
                </div>
            </div>
            <div class="four_item">
                <div class="four_item_content">
                    <el-image :src="require('@/assets/management/图4-2.png')" alt="" style="width: 100%;"
                        :preview-src-list="[require('@/assets/management/图4-2.png')]" />
                </div>
                <div class="four_item_title">
                    <h1>{{ $t("user.managementh4_3") }}</h1>
                    <p>{{ $t("user.managementh4_4") }}</p>
                </div>
            </div>
            <div class="four_item">
                <div class="four_item_title">
                    <h1>{{ $t("user.managementh4_5") }}</h1>
                    <p>{{ $t("user.managementh4_6") }}</p>
                </div>
                <div class="four_item_content">
                    <el-image :src="require('@/assets/management/图4-3.png')" alt="" style="width: 100%;"
                        :preview-src-list="[require('@/assets/management/图4-3.png')]" />
                </div>
            </div>

        </div>
        <!-- 5，6 -->
        <div class="management-container">
            <div class="management-column">
                <h2 class="column_title">
                    <span class="title_num">05</span>
                    <span class="title_text">{{ $t("user.managementh5") }}</span>

                    <hr class="line">
                </h2>
                <!-- 图片+描述 行1 -->
                <div class="five">
                    <div class="five_img">
                        <el-image :src="require('@/assets/management/图5-1.png')" alt="" style="margin-left: 70px;"
                            :preview-src-list="[require('@/assets/management/图5-1.png')]" />
                        <span>{{ $t("user.managementh5_1") }}</span>
                        <el-image :src="require('@/assets/management/图5-2.png')" alt="" style="margin-left: 70px;"
                            :preview-src-list="[require('@/assets/management/图5-2.png')]" />
                        <span>{{ $t("user.managementh5_2") }}</span>
                    </div>
                    <div class="five_content">
                        <ul>
                            <li><span>● </span> {{ $t("user.managementh5_3") }}</li>
                            <li><span>●</span> {{ $t("user.managementh5_4") }}</li>
                            <li><span>●</span> {{ $t("user.managementh5_5") }}</li>
                            <li><span>●</span> {{ $t("user.managementh5_6") }}</li>
                            <li><span>●</span> {{ $t("user.managementh5_7") }}</li>
                            <li><span>●</span> {{ $t("user.managementh5_8") }}</li>
                            <li><span>●</span> {{ $t("user.managementh5_9") }}</li>
                            <li><span>●</span> {{ $t("user.managementh5_10") }}</li>
                        </ul>
                    </div>
                </div>
            </div>
            <!-- 右侧：精益求精，铸就精品 -->
            <div class="management-column">
                <h2 class="column_title">
                    <span class="title_num">06</span>
                    <span class="title_text">{{ $t("user.managementh6") }}</span>
                    <hr class="line">
                </h2>
                <!-- 图片+描述 行1 -->
                <div class="six">
                    <div class="six_img">
                        <el-image :src="require('@/assets/management/图6.png')" alt=""
                            :preview-src-list="[require('@/assets/management/图6.png')]" />
                    </div>
                    <div class="six_content"><span>●</span> {{ $t("user.managementh6_1") }}</div>

                </div>
            </div>
        </div>
        <!-- 7，8 -->
        <div class="management-container">
            <div class="management-column">
                <h2 class="column_title">
                    <span class="title_num">07</span>
                    <span class="title_text">{{ $t("user.managementh7") }}</span>
                    <hr class="line">
                </h2>
                <!-- 图片+描述 行1 -->
                <div class="seven">
                    <div class="seven_img">
                        <el-image :src="require('@/assets/management/图7.png')" alt=""
                            :preview-src-list="[require('@/assets/management/图7.png')]" />
                    </div>
                    <div class="seven_content">
                        <span>●</span> {{ $t("user.managementh7_1") }}

                    </div>
                </div>
            </div>
            <!-- 右侧：精益求精，铸就精品 -->
            <div class="management-column">
                <h2 class="column_title">
                    <span class="title_num">08</span>
                    <span class="title_text">{{ $t("user.managementh8") }}</span>
                    <hr class="line">
                </h2>
                <!-- 图片+描述 行1 -->
                <div style="margin-top: 30px;margin-left: 30px;color: #66B882;font-weight: bolder;font-size: 18px;">
                    1、{{ $t("user.managementh8_1") }}</div>
                <div class="eight">
                    <div class="eight_img">
                        <el-image :src="require('@/assets/management/图8-1.png')" alt=""
                            :preview-src-list="[require('@/assets/management/图8-1.png')]" />
                    </div>
                    <div class="eight_content">
                        <div class="row">
                            <div class="green">{{ $t("user.managementh8_2") }}</div>
                            <div class="black">{{ $t("user.managementh8_3") }}</div>
                        </div>
                        <div class="row">
                            <div class="black">{{ $t("user.managementh8_4") }}</div>
                            <div class="green">{{ $t("user.managementh8_5") }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 9 -->
        <div class="management-container">
            <div class="management-column">
                <h2 class="column_title">
                    <span class="title_num">09</span>
                    <span class="title_text">{{ $t("user.managementh9") }}</span>

                    <hr class="line">
                </h2>
                <div class="nine">
                    <div class="nine_item">
                        <el-image :src="require('@/assets/management/图9-1.png')" alt="" style="width: 100%;"
                            :preview-src-list="[require('@/assets/management/图9-1.png')]" />
                        <div style="text-align: center;margin-top: 20px;">
                            ● {{ $t("user.managementh9") }}
                        </div>
                    </div>
                    <div class="nine_item">
                        <el-image :src="require('@/assets/management/图9-2.png')" alt="" style="width: 100%;"
                            :preview-src-list="[require('@/assets/management/图9-2.png')]" />
                        <div style="text-align: center;margin-top: 20px;">
                            ● {{ $t("user.managementh9_1") }}
                        </div>
                    </div>
                </div>
            </div>
            <!-- 右侧：精益求精，铸就精品 -->
            <div class="management-column">
                <div style="margin-top: 20px;margin-left: 30px;color: #66B882;font-weight: bolder;font-size: 18px;">
                    2、{{ $t("user.managementh8_6") }}</div>
                <!-- 图片+描述 行1 -->
                <el-image :src="require('@/assets/management/图8-2.png')" alt=""
                    style="width: 100%;margin-top: 30px;padding-left: 50px;"
                    :preview-src-list="[require('@/assets/management/图8-2.png')]" />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Management',
    data() {
        return {
            title: '精细化管理模式'
        }
    },
    mounted() {
        document.title = this.title;
    }
}
</script>

<style lang="scss" scoped>
// 容器样式
.management-container {
    display: flex;
    justify-content: space-between;
    padding: 40px 80px;
    gap: 40px;
}

.management-column {
    flex: 1;
}

// 栏标题
.column_title {
    font-size: 24px;
    color: #000;
    /* 左侧绿色竖线 */
    padding-left: 10px;
    margin-bottom: 20px;

    .title_num {
        background-color: #6DBA50;
        padding: 10px 5px;
        color: white;
        margin-right: 10px;
    }

    .title_text {
        color: #6DBA50;
        width: 100%;
        white-space: nowrap;
    }

    .line {
        flex: 1;
        height: 2px;
        background-color: #858483;
        border: none;
        margin: 5px 8px;
        width: 100%;
    }
}

// 行布局（每行放多个 item）
.row {
    display: flex;
    justify-content: space-between;
    margin-bottom: 30px;
    flex-direction: row;
    gap: 20px;
}

// 单个 item 样式（图片+文字）
.Mitem {
    // width: calc(33.333% - 20px);
    text-align: left;

    .Mitem_text {
        text-align: center;
        color: #6DBA50;
        margin-top: 8px;
        position: relative;
        font-size: 12px;
    }
}

.three {
    background-image: url('@/assets/management/图3.png');
    background-size: 100% auto;
    object-fit: contain;
    width: 100%;
    height: 750px;
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    align-items: center;

    .three_ul {
        margin-top: -200px;
        height: 100%;
        display: flex;
        flex-direction: column;
        width: 530px;
        height: 100%;
        margin-left: 100px;

        li {
            list-style: disc;
            margin-top: 10px;
            color: #68AD4A;
            font-size: 18px;
        }
    }
}

.three_main {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;

    .three_main_item {
        border: 1px solid #68AD4A;
        // padding: 20px 30px;
        padding-left: 20px;
        width: 330px;
        height: 120px;
        border-radius: 10px;
        justify-content: center;
        display: flex;
        flex-direction: column;

        .title {
            font-size: 30px;
            color: #549E39;
            font-weight: bolder;
        }

        .content {
            font-size: 16px;
            color: #68AD4A;

        }

    }
}

.four {
    width: 90%;
    margin: 0 auto;
    display: flex;
    flex-direction: row;

    .four_item {
        width: 33.3%;
        display: flex;
        flex-direction: column;
        height: 700px;
        background-color: #F4F4F4;

        .four_item_title {
            font-size: 20px;
            color: white;
            flex: 1;
            height: 50%;
            background-color: #68AD4A;
            padding: 0px 30px;
            height: 50%;

            h1 {
                font-weight: bolder;
                font-size: 22px;
                border-bottom: 1px solid white;
                padding-bottom: 10px;
                margin-top: 60px;
            }

            p {
                font-size: 16px;
                font-weight: 400;
                color: #FAFCF9;
                margin-top: 20px;
                // padding-bottom: 45px;
            }
        }

        .four_item_content {
            flex: 1;
            height: 50%;
            width: 100%;

            img {
                width: 100%;
                height: 100%;
                object-fit: contain;
            }

        }
    }
}

.five {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .five_img {
        margin-top: 30px;
        display: flex;

        span {
            font-size: 16px;
            display: flex;
            color: #74BF5B;
            align-items: flex-end;
            margin-left: -12%;
            font-weight: bold;
        }

        el-image {
            margin-left: 70px;
        }
    }

    .five_content {
        margin-top: 50px;

        ul {
            span {
                color: #68AD4A;
            }

            li {
                font-size: 16px;
                color: black;
                // font-weight: bold;
            }
        }
    }

}

.six {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0 9%;

    .six_img {
        margin-top: 30px;
    }

    .six_content {
        margin-top: 50px;
        font-size: 16px;
        color: black;

        span {
            color: #68AD4A;
        }
    }
}

.seven {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 30px;

    .seven_img {
        width: 35%;
    }

    .seven_content {
        width: 58%;
        color: black;
        font-size: 16px;

        span {
            color: #68AD4A;
        }
    }


}

.eight {
    margin-top: 20px;
    display: flex;
    flex-direction: row;
    margin-left: 45px;
    height: 226px;

    .eight_content {
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 100%;

        .row {
            width: 110%;
            height: 50%;
            margin-bottom: 0;

            .green {
                padding: 0 10px;
                width: 50%;
                height: 105px;
                background-color: #6DBA50;
                border-radius: 20px;
                display: flex;
                justify-content: center;
                align-items: center;
                color: white;

            }

            .black {
                padding: 0 10px;
                width: 50%;
                height: 105px;
                background-color: #F4F4F4;
                border-radius: 20px;
                display: flex;
                justify-content: center;
                align-items: center;
                color: black;
            }
        }
    }
}

.nine {
    display: flex;
    flex-direction: row;
    margin-top: 50px;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: 0 20px;

    .nine_item {
        color: #68AD4A;
    }

}

// 适配小屏幕：让 item 换行且宽度调整
@media (max-width: 768px) {
    .item {
        width: calc(50% - 20px);
        /* 每行2个 */
    }
}

@media (max-width: 480px) {
    .item {
        width: 100%;
        /* 每行1个 */
    }
}

// 原有样式
.about_one {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    font-size: 20px;
    margin-bottom: 10px;
    flex-direction: column;
    /* 标题居中 */
    text-align: center;
}

.line {
    flex: 1;
    height: 2px;
    background: #000;
    width: 50px;
    align-items: center;
    display: flex;
    margin-top: 18px;
}
</style>